<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon
        class="mt-n1"
        v-on="on"
      >
        <v-icon color="purple">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Edit Employee's History"
      text="Edit Employee Personal Detail History Record"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localHistory.subject"
                :items="subjects"
                item-text="name"
                item-value="key"
                label="Subject"
                outlined
                readonly
                disabled
                filled
              />
            </v-col>

            <v-col
              v-if="localHistory.subject === 'marital_status'"
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localHistory.previous_value"
                v-validate="'required'"
                :items="maritalStatuses"
                :error-messages="errors.collect('previousValue')"
                data-vv-name="previousValue"     
                data-vv-as="previous value"
                label="Previous Value"
                item-text="value"
                item-value="value"
                hide-no-data
                hide-selected
                outlined
              />
            </v-col>

            <v-col
              v-else-if="localHistory.subject === 'religion'"
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localHistory.previous_value"
                v-validate="'required'"
                :items="religions"
                :error-messages="errors.collect('previousValue')"
                data-vv-name="previousValue"     
                data-vv-as="previous value"
                label="Previous Value"
                item-text="value"
                item-value="value"
                hide-no-data
                hide-selected
                outlined
              />
            </v-col>

            <v-col
              v-else-if="localHistory.subject === 'phone_number' || localHistory.subject === 'handphone_number'"
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localHistory.previous_value"
                v-validate="'required|phoneLength'"
                v-mask="['###-########']"
                :error-messages="errors.collect('previousValue')"
                data-vv-name="previousValue"     
                data-vv-as="previous value"
                label="Previous Value"
                outlined
              />
            </v-col>
            
            <v-col
              v-else-if="localHistory.subject === 'marriage_date'"
              cols="12"
              class="pb-0"
            >
              <v-menu
                v-model="previousValueDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="marriageDateDisplay"
                    v-validate="'required'"
                    :error-messages="errors.collect('marriageDateDisplay')"
                    data-vv-name="marriageDateDisplay"
                    data-vv-as="marriage date"
                    label="Marriage date"
                    outlined
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localHistory.previous_value"
                  no-title
                  :max="today"
                  @input="previousValueDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              v-else
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localHistory.previous_value"
                v-validate="localHistory.subject === 'name' ? 'required|max:80|nameAllowedFormat' : localHistory.subject === 'email' ? 'required|email' : 'required'"
                :error-messages="errors.collect('previousValue')"
                data-vv-name="previousValue"     
                data-vv-as="previous value"
                label="Previous Value"
                outlined
                @input="localHistory.subject === 'name' ? localHistory.previous_value = localHistory.previous_value.toUpperCase() : ''"
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDateDisplay"
                    v-validate="'required'"
                    :error-messages="errors.collect('startDateDisplay')"
                    data-vv-name="startDateDisplay"
                    data-vv-as="start date"
                    label="Start date"
                    outlined
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localHistory.start_date"
                  no-title
                  :max="localHistory.end_date"
                  @input="startDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDateDisplay"
                    v-validate="'required'"
                    :error-messages="errors.collect('endDateDisplay')"
                    data-vv-name="endDateDisplay"
                    data-vv-as="end date"
                    label="End date"
                    outlined
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localHistory.end_date"
                  no-title
                  :min="localHistory.start_date"
                  @input="endDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card> 
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      history: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        startDateMenu: false,
        endDateMenu: false,
        previousValueDateMenu: false,
        localHistory: null,
        maritalStatuses: [],
        religions: [],
        today: new Date().toISOString().slice(0, 10), 
        subjects: [
          { key: 'name', name: 'Name' },
          { key: 'religion', name: 'Religion' },
          { key: 'email', name: 'Email' },
          { key: 'personal_email_address', name: 'Personal Email Address' },
          { key: 'phone_number', name: 'Phone Number' },
          { key: 'handphone_number', name: 'Handphone Number' },
          { key: 'marital_status', name: 'Marital Status' },
          { key: 'marriage_date', name: 'Marriage Date' },
          { key: 'address', name: 'Address' },
        ],
      }
    },
    computed: {
      startDateDisplay () {
        return this.localHistory.start_date ? this.$moment(this.localHistory.start_date, 'YYYY-MM-DD').format('DD MMM YYYY') : ''
      },
      endDateDisplay () {
        return this.localHistory.end_date ? this.$moment(this.localHistory.end_date, 'YYYY-MM-DD').format('DD MMM YYYY') : ''
      },
      marriageDateDisplay () {
        return this.localHistory.previous_value ? this.$moment(this.localHistory.previous_value, 'YYYY-MM-DD').format('DD MMM YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return 
        this.localHistory = { ...this.history }

        this.loading = true

        this.$validator.extend('nameAllowedFormat', {
          getMessage (field, args) {
            return "Invalid name format. Only alphabet and special character of @ ' * - / . allowed for name"     
          },
          validate (value, args) {
            const regex = /^[ A-Za-z'@./*-]*$/
            return regex.test(value)
          },
        })

        this.$validator.extend('phoneLength', {
          getMessage (field, args) {
            return 'Invalid phone number (at least 9 numbers and max 11)'
          },
          validate (value, args) {
            return value.toString().length >= 10 && value.toString().length <= 12
          },
        })

        Promise.all([
          this.$api.hrisPersonMaritalStatus().list(),
          this.$api.religions().list(),
        ])
          .then(([maritalStatus, religions]) => {
            this.maritalStatuses = maritalStatus.data
            this.religions = religions.data

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.personHistories().update(this.history.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          subject: this.localHistory.subject,
          previous_value: this.localHistory.previous_value,
          start_date: this.localHistory.start_date,
          end_date: this.localHistory.end_date,
        }
      },
    },
  }
</script>

<style scoped>
.required >>> fieldset {
  border: 2px solid red;
}

.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:1px
}
</style>
